import { render, staticRenderFns } from "./EpotInputGrupSoal.vue?vue&type=template&id=d1b9881a&"
import script from "./EpotInputGrupSoal.vue?vue&type=script&lang=js&"
export * from "./EpotInputGrupSoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports